import {defineStyle, defineStyleConfig} from '@chakra-ui/styled-system'

import borders from 'airship/design-system/theme/foundations/borders'
import colors from 'airship/design-system/theme/foundations/colors'
import opacity from 'airship/design-system/theme/foundations/opacity'

import typography from '../foundations/typography'

const outline = defineStyle({
  ...typography.textStyles.body.medium,
  borderRadius: borders.radii['2xs'],
  borderColor: colors.border.primary,
  borderWidth: 1,
  backgroundColor: colors.background.primary,
  _hover: {
    backgroundColor: colors.background['primary-hover'],
  },
  _disabled: {
    opacity: opacity[40],
  },
  _invalid: {
    borderColor: colors.border.error,
    borderWidth: 1,
  },
  _selected: {
    borderColor: colors.border.brand,
    borderWidth: 2,
  },
})

const TextareaTheme = defineStyleConfig({
  variants: {outline},
})

export default TextareaTheme
